import {createFileRoute} from '@tanstack/react-router'
import LoginView from "../../LoginView.tsx";

export const Route = createFileRoute('/login/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <LoginView />
}
